import { ValidatorFn } from '@angular/forms';
import { isEmptyString, isNil } from '@web/utils';
import { ValidationError } from '../enums/validation-error';

export class UrlValidator {
  public static url = ((): ValidatorFn => {
    return (control) => {
      const { value } = control;

      if (isEmptyString(value)) {
        return null;
      }

      if (isNil(value)) {
        return null;
      }

      try {
        new URL(value);

        return null;
      } catch (_) {
        return {
          [ValidationError.URL]: true,
        };
      }
    };
  })();
}
